<template>
  <div class="lxm-activity-item box">
    <div class="level is-mobile">
        <div class="level-item has-text-left" @click="goToFeedbackPage">
          <p class="lxm-activity-item__name">{{ title }}</p>
        </div>
        <div class="level-item has-text-centered" @click="goToFeedbackPage">
          <p class="lxm-activity-item__value">{{ value }}</p>
          <p class="lxm-activity-item__sub">{{ valueSuffix }}</p>
        </div>

      <div class="level-item scan-icon-item" @click="onScanClicked">
        <p class="lxm-activity-item__value scan-icon">scan</p>
        <p class="lxm-activity-item__sub">扫码签到</p>
      </div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  a.lxm-activity-item.box
    color: grey-darker
  .lxm-activity-item
    &.box
      padding: spacing-small spacing
      &:not(:last-child)
        margin-bottom: spacing
  .lxm-activity-item__name
    font-size: size
    text-overflow-ellipsis(siz(200))
  .lxm-activity-item__value
    font-size: size-big
    height 1.48rem
    color: brand-primary
  .lxm-activity-item__sub
    font-size: size-small
    color: grey-dark
    margin-top: spacing-small
  .has-text-centered
    display flex
    justify-content center
    flex-wrap wrap
  .scan-icon-item
    display flex
    justify-content center
    flex-wrap: wrap
  .scan-icon
    color transparent
    height 1.48rem
    width 1.48rem
    background-size cover
    background-image url("https://s.lingxi360.com/mobile/img/scan1scan.png")
</style>

<script>
  import * as mTypes from '../../../store/mutation-types'
  export default {
    props: {
      id: String,
      title: String,
      value: [String, Number],
      valueSuffix: String,
      to: Object
    },
    data () {
      return {
        withScan: false
      }
    },
    computed: {
    },
    methods: {
      goToFeedbackPage () {
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.push({
          name: 'activityFeedback',
          query: {
            activityId: this.id
          }
        })
      },
      goToActivity () {
        if (this.to) {
          this.$store.commit(mTypes.TRANSITION_SET_BACK)
          this.$router.push(this.to)
        }
      },
      onScanClicked () {
        this.to.query = {
          ...this.to.query,
          scan: 1
        }
        this.goToActivity()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmActivityItem.vue?749ec1cf